import React from 'react'
import UserLayout from '../layout/UserLayout'
import {useSelector} from "react-redux"
import MetaData from '../layout/MetaData'
import '../../css/Profile.css'
import '../../css/Driver.css'

const Profile = ()  => {
  const {user} = useSelector((state) => state.auth)

  return ( 
  <UserLayout>
        <> 
        <MetaData title ={'Profile'} />
     <div className="row justify-content-around mt-5 user-info" id='user-profile'>
      <div className="col-12 col-md-3">
        <figure className="avatar avatar-profile">
          <img
            className="rounded-circle img-fluid"
            id='profile-page-pic'
            src={user?.avatar ? user?.avatar?.url : "/images/default_avatar.jpg"}
            alt={user?.name}
          />
        </figure>
      </div>

      <div className="col-12 col-md-5">
        <h4>Full Name</h4>
        <p>{user?.name}</p>

        <h4>Phone Number</h4>
        <p>0{user?.phoneNo  || "No Phone Number linked with account"}</p>

        <h4>Email Address</h4>
        <p>{user?.email  || "No email address linked with account"}</p>

        <h4>Joined On</h4>
        <p>{user?.createdAt?.substring(0,10)}</p>
      </div>
    </div>
 
    {user?.role === 'driver' && (
          <>
            <br />
            <br />
            <h2 className='fw-bolder'>CNIC:</h2>
            <br />
            <div className="col-12 col-md-3">
              <figure className="">
                <img 
                  id="usercnic"
                  src={user?.CNIC?.url}
                  alt={user?.vehicleRegistration?.url}
                />
              </figure>
            </div>

            <br />
            <br />
            <h2 className='fw-bolder'>Vehicle Registration:</h2>
            <br />
            <div className="col-12 col-md-3">
            <figure className="">
                <img
                  id="usercnic"
                  src={user?.vehicleRegistration?.url}
                  alt={user?.vehicleRegistration?.url}
                />
              </figure>
            </div>

            <br />
            <br />
            <h2 className='fw-bolder'>Driving License:</h2>
            <br />
            <div className="col-12 col-md-3">
              <figure className="">
                <img
                  id="usercnic"
                  src={user?.drivingLicense?.url}
                  alt={user?.drivingLicense?.url}
                />
              </figure>
            </div>
          </>
        )}

      </>
    </UserLayout>
  )
}

export default Profile